import { render, staticRenderFns } from "./detailsMessageTeacher.vue?vue&type=template&id=219cb33c&"
import script from "./detailsMessageTeacher.vue?vue&type=script&lang=js&"
export * from "./detailsMessageTeacher.vue?vue&type=script&lang=js&"
import style0 from "./detailsMessageTeacher.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports